import React, { useCallback, useMemo, useState } from 'react';

import { useGetNotificationsQuery } from 'api/main';
import { parseReceivedNotifications } from 'utils/helpers';
import { ORDER_BY, sortDirection } from 'utils/constants';
import { texts } from 'utils/languages/fr';

import PageWrapper from './PageWrapper';
import { CustomPagination, Loader, MessageGroup } from 'components';

const InvestorMessages = () => {
    const [page, setPage] = useState(1);

    const {
        data: { notifications = [], lastPage } = { data: { notifications: [] } },
        isLoading: notificationsLoader,
    } = useGetNotificationsQuery({
        page,
        orderBy: ORDER_BY.createdAt,
        direction: sortDirection.DESC,
    });

    const messages = useMemo(
        () =>
            parseReceivedNotifications(
                notifications.map(n => n[0]),
                true
            ),
        [notifications]
    );

    const handlePageChange = useCallback(page => () => setPage(page), []);

    return (
        <PageWrapper title={texts.MY_MESSAGES}>
            <Loader loading={notificationsLoader}>
                <MessageGroup messages={messages} />
            </Loader>
            <CustomPagination
                currentPage={page}
                lastPage={lastPage}
                changePage={handlePageChange}
            />
        </PageWrapper>
    );
};

export default InvestorMessages;
